import React from 'react';
import { Helmet } from 'react-helmet';
import AppFonts from './AppFonts';
import Logo from './Logo';
import { ThemeProvider } from './ThemeContext';
import '../../styles/app2.css';

/**
 * Marco para las pantallas SUELTAS del rediseño: las que viven fuera de /app/*
 * y por lo tanto no tienen shell (cambio obligatorio de contraseña, aterrizaje
 * del magic-link, 404, documentos legales).
 *
 * Hace lo mínimo que necesitan para verse como la app: monta el wrapper `.as2`
 * (donde viven los tokens), carga las fuentes y aplica el tema guardado.
 *
 * @param {number} maxWidth   ancho máximo del contenido (px)
 * @param {string} title      título del documento
 * @param {'center'|'top'} align  centrado vertical (tarjetas cortas) o desde
 *                                arriba (documentos largos)
 * @param {boolean} logo      pinta el logo de PaySlip sobre el contenido
 * @param {node} actions      acciones opcionales junto al logo (p. ej. "Volver")
 */
const StandaloneScreen = ({
  children,
  maxWidth = 520,
  title,
  align = 'center',
  logo = true,
  actions = null,
}) => (
  <div
    className="as2"
    style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center',
      justifyContent: align === 'center' ? 'center' : 'flex-start',
      gap: 22,
      padding: 'clamp(20px,5vw,48px)',
    }}
  >
    <ThemeProvider>
      <AppFonts />
      {title ? <Helmet><title>{title}</title></Helmet> : null}

      {logo || actions ? (
        <div
          style={{
            width: '100%', maxWidth, display: 'flex', alignItems: 'center',
            justifyContent: logo && actions ? 'space-between' : 'center',
            flexWrap: 'wrap', gap: 12,
          }}
        >
          {logo ? <Logo size={38} /> : null}
          {actions}
        </div>
      ) : null}

      <div style={{ width: '100%', maxWidth }}>
        {children}
      </div>
    </ThemeProvider>
  </div>
);

export default StandaloneScreen;
